/**
 * Alarm-category chip for the operations-dashboard alarm/repair grids.
 * Colors by severity first (critical/high/warning/attention/info), falling
 * back to the legacy per-category color map for rows that predate the
 * severity field, and appends an `x{count}` suffix when an alarm repeated.
 *
 * Contains:
 * - AlarmChip — default export
 */

import React from 'react';

import BaseAlarmChip from '@sophocles/components/AlarmChip';

const SEVERITY_CHIP_FAMILY = {
  critical: 'bad',
  high: 'bad',
  warning: 'warning',
  attention: 'attention',
  info: 'info',
};

const CATEGORY_CHIP_FAMILY = {
  // Red
  loss_of_power: 'bad',
  no_video_out: 'bad',
  no_video: 'bad',
  stuck_video: 'bad',
  relay_no_current: 'bad',
  // Orange/Yellow
  offline: 'warning',
  tamper: 'warning',
  intrusion: 'warning',
  low_voltage: 'warning',
  relay_bulb_fault: 'warning',
  no_sensor: 'warning',
  // Blue
  external_override: 'info',
};

export default function AlarmChip({ shortName, categoryShortName, tAlarm, count, severity }) {
  if (!shortName) return null;
  const label = tAlarm(`alarms.${shortName}`, { defaultValue: shortName.replace(/_/g, ' ') });
  const displayLabel = count > 1 ? `${label} \xd7${count}` : label;
  const family = SEVERITY_CHIP_FAMILY[severity] || CATEGORY_CHIP_FAMILY[categoryShortName] || 'neutral';
  return <BaseAlarmChip label={displayLabel} color={family} />;
}
